import { createModelSegment } from 'client/data/luckdragon/segment';

export const MatchedRouteModel = createModelSegment('matchedRoute', []);
